var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVehicleRoof(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.824 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.647,8l3.036,3.289a.53.53,0,1,1-.778.718L11.647,9.56v2.879A1.06,1.06,0,0,1,10.588,13.5H4.235a1.06,1.06,0,0,1-1.059-1.061V9.56L.918,12.006a.53.53,0,1,1-.778-.718L3.176,8V7.815a.52.52,0,0,0,.019-.071,1.06,1.06,0,0,1,1.04-.862h6.353a1.06,1.06,0,0,1,1.04.862.557.557,0,0,0,.019.071Zm0,8.412A1.589,1.589,0,0,1,10.058,18H4.766a1.59,1.59,0,0,1-1.589-1.589V14.275a2.108,2.108,0,0,0,1.059.284h6.353a2.105,2.105,0,0,0,1.059-.284ZM3.176,1.589A1.589,1.589,0,0,1,4.766,0h5.292a1.59,1.59,0,0,1,1.589,1.589V6.107a2.109,2.109,0,0,0-1.059-.284H4.235a2.109,2.109,0,0,0-1.059.284Z",
    transform: "translate(0)",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleRoof);
export default __webpack_public_path__ + "static/media/VehicleRoof.175d375373adc1caa41d6067400f1365.svg";
export { ForwardRef as ReactComponent };